// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import ProductLeadTime from "@awc/App/Components/Product/ProductLeadTime";
import ProductPrice, { ProductPriceStyles } from "@awc/Overrides/Components/ProductPrice";
import ProductQuantityOrdered from "@awc/Overrides/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@awc/Overrides/Components/ProductUnitOfMeasureSelect";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface OwnProps {
    isOpen?: boolean;
    closeModalHandler: () => void;
}

type Props = OwnProps & HasProductContext;

interface SelectOptionsModalStyles {
    modal?: ModalPresentationProps;
    container?: InjectableCss;
    productUnitOfMeasureSelect?: SelectPresentationProps;
    productQuantityOrdered?: TextFieldPresentationProps;
    productPriceStyles?: ProductPriceStyles;
    productAddToCartButton?: ButtonPresentationProps;
    qtyWrapper?: InjectableCss;
}

export const selectOptionsModalStyles: SelectOptionsModalStyles = {};

const styles = selectOptionsModalStyles;
const SelectOptionsModal: FC<Props> = ({ productContext, isOpen, closeModalHandler }) => {
    return (
        <Modal
            {...styles.modal}
            headline={translate("Select options before adding to order")}
            isOpen={isOpen}
            handleClose={closeModalHandler}
            data-test-selector="modal_ProductSelectorSelectOptions"
        >
            <StyledWrapper {...styles.container}>
                <ProductUnitOfMeasureSelect displayPack={true} labelOverride={translate("Length:")} />
                <StyledWrapper {...styles.qtyWrapper}>
                    <ProductQuantityOrdered labelOverride={translate("Quantity")} showLabel={true} />
                </StyledWrapper>
                <ProductPrice showLabel={false} product={productContext} extendedStyles={styles.productPriceStyles} />
                <ProductLeadTime />
                <ProductAddToCartButton
                    data-test-selector="addToCartBtn"
                    extendedStyles={styles.productAddToCartButton}
                    {...{ closeModalHandler }}
                />
            </StyledWrapper>
        </Modal>
    );
};

export default withProductContext(SelectOptionsModal);
